import { Component } from '@angular/core';
import { AlphaSharedModule, PrimeNGModules } from '../../shared/alpha-shared.module';

@Component({
    selector: 'app-groups',
    standalone: true,
    imports: [AlphaSharedModule, ...PrimeNGModules],
    templateUrl: './groups.component.html',
    styleUrl: './groups.component.scss',
})
export class GroupsComponent {}
